module.exports = __webpack_public_path__ + "img/395.c487b63b.jpg";